import { ErrorHandlingModal } from 'components/ErrorHandlingModal';
import { ModalLoading } from 'components/ModalLoading';
import type { ContractChangeStatusEnum } from 'gql/graphql';
import { Button } from 'uikit';

import { useCallback } from 'react';

import { useUploadAgreement } from '../hooks/useUploadAgreement';

interface ICurrentAgreementId {
    currentAgreementId: number;
    currentAgreementStatus: ContractChangeStatusEnum | undefined;
    className?: string;
    rulesAccessDisabled?: boolean;
    disabledUnloadButton?: boolean;
}

export const UploadAgreement = ({
    currentAgreementId,
    currentAgreementStatus,
    className,
    rulesAccessDisabled,
    disabledUnloadButton,
}: ICurrentAgreementId) => {
    const {
        isSubmitted,
        exportContractData,
        exportContractStatus,
        exportContractError,
        handleUploadAgreement,
        handleCloseUploadAgreementError,
        handleCreateReportUploadAgreement,
        cancelCopyRequest,
        isCopying,
    } = useUploadAgreement({
        currentAgreementId,
        currentAgreementStatus,
    });

    const uploadHandler = useCallback(() => {
        handleUploadAgreement(undefined, undefined);
    }, [handleUploadAgreement]);

    return (
        <>
            <Button
                label="Выгрузить"
                view="secondary"
                size="s"
                className={className}
                onClick={uploadHandler}
                loading={isCopying}
                disabled={rulesAccessDisabled || disabledUnloadButton}
            />
            {isCopying && <ModalLoading title="Выгрузка аналитики по ДС" onClose={cancelCopyRequest} />}
            <ErrorHandlingModal
                titleText="Выгрузка доп. соглашения"
                isSubmitted={isSubmitted}
                statusRequest={exportContractStatus}
                dataRequest={exportContractData}
                errorsRequest={exportContractError}
                handleCloseModalError={handleCloseUploadAgreementError}
                handleCreateReport={handleCreateReportUploadAgreement}
            />
        </>
    );
};

UploadAgreement.displayName = 'UploadAgreement';
